import { z } from "zod";
export const incidentSeverities = ["P1", "P2", "P3", "P4"];
export const incidentStatuses = [
    "reported",
    "investigating",
    "identified",
    "monitoring",
    "resolved",
    "closed",
];
export const tenantRoles = ["viewer", "responder", "manager", "tenant_admin"];
export const incidentSeveritySchema = z.enum(incidentSeverities);
export const incidentStatusSchema = z.enum(incidentStatuses);
export const tenantRoleSchema = z.enum(tenantRoles);
export const memberInviteSchema = z.object({
    discordUserId: z.string().regex(/^\d{5,30}$/),
    displayName: z.string().trim().max(100).optional().default(""),
    role: tenantRoleSchema.default("viewer"),
});
export const memberRoleUpdateSchema = z.object({
    role: tenantRoleSchema,
});
export const createIncidentSchema = z.object({
    title: z.string().trim().min(3).max(160),
    severity: incidentSeveritySchema,
    service: z.string().trim().min(1).max(100),
    impact: z.string().trim().min(3).max(4000),
    details: z.string().trim().max(4000).default(""),
    occurredAt: z.string().trim().max(64).optional(),
});
export const updateIncidentSchema = z.object({
    status: incidentStatusSchema.optional(),
    assigneeName: z.string().trim().max(100).nullable().optional(),
    rootCause: z.string().trim().max(1000).nullable().optional(),
    recurrenceKey: z.string().trim().max(160).nullable().optional(),
    postmortemStatus: z.enum(["not_required", "pending", "draft", "published"]).optional(),
    postmortemUrl: z.string().url().max(1000).nullable().optional(),
});
const githubNameSchema = z
    .string()
    .trim()
    .min(1)
    .max(100)
    .regex(/^[A-Za-z0-9_.-]+$/);
export const githubIntegrationSettingsSchema = z.object({
    token: z.string().trim().max(1000).optional().default(""),
    owner: githubNameSchema,
    repository: githubNameSchema,
    projectOwner: githubNameSchema.nullable(),
    projectNumber: z.number().int().positive().max(1_000_000).nullable(),
    labels: z.array(z.string().trim().min(1).max(100)).max(50),
    assignees: z.array(githubNameSchema).max(20),
});
export const tenantSettingsSchema = z
    .object({
    name: z.string().trim().min(2).max(100),
    timezone: z.string().trim().min(1).max(64),
    incidentChannelId: z
        .string()
        .regex(/^\d{5,30}$/)
        .nullable(),
    ticketProvider: z.enum(["internal", "github"]),
    ticketProject: z.string().trim().max(120).nullable(),
    github: githubIntegrationSettingsSchema.nullable().optional(),
    allowedRoleIds: z.array(z.string().regex(/^\d{5,30}$/)).max(100),
    p1RoleIds: z.array(z.string().regex(/^\d{5,30}$/)).max(100),
    reportChannelId: z
        .string()
        .regex(/^\d{5,30}$/)
        .nullable()
        .default(null),
    weeklyReportsEnabled: z.boolean().default(false),
    monthlyReportsEnabled: z.boolean().default(false),
    slaHours: z
        .object({
        P1: z.number().positive().max(8760),
        P2: z.number().positive().max(8760),
        P3: z.number().positive().max(8760),
        P4: z.number().positive().max(8760),
    })
        .default({ P1: 1, P2: 4, P3: 24, P4: 72 }),
})
    .superRefine((value, context) => {
    if (value.ticketProvider === "github" && !value.github) {
        context.addIssue({
            code: "custom",
            path: ["github"],
            message: "GitHub integration settings are required",
        });
    }
});
export const severityLabels = {
    P1: "Critical",
    P2: "High",
    P3: "Moderate",
    P4: "Low",
};
export const statusLabels = {
    reported: "報告済み",
    investigating: "調査中",
    identified: "原因特定",
    monitoring: "監視中",
    resolved: "復旧",
    closed: "クローズ",
};
